<template>
    <div class="employee-match-candidates">
        <div v-for="candidate in candidates" :key="candidate.employee_id" class="employee-match-candidate">
            <router-link :to="{name: 'employee-details', params: {id: candidate.employee_id}}"
                target="_blank" rel="noopener noreferrer" title="Открыть карточку сотрудника в новой вкладке">
                #{{ candidate.employee_id }} · {{ candidate.display_name || candidate.full_name }} ↗
            </router-link>
            <small v-if="candidate.match_decision === 'reject'" class="d-block text-muted">
                Ранее отмечен как другой человек<span v-if="candidate.match_decision_reason">: {{ candidate.match_decision_reason }}</span>
            </small>
            <div class="employee-match-evidence">
                <span v-for="item in candidate.match_evidence || []" :key="item.field"
                    :class="{'text-danger': item.state === 'different', 'text-warning': item.state === 'typo'}">{{ item.text }}</span>
            </div>
            <b-form-checkbox v-if="editable && Number(candidate.employee_id) !== Number(selectedId)"
                :checked="value.includes(Number(candidate.employee_id))" :disabled="disabled"
                @change="toggle(candidate.employee_id, $event)">
                Другой человек — запомнить
            </b-form-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmployeeMatchCandidates',
    props: {
        candidates: {type: Array, default: () => []},
        value: {type: Array, default: () => []},
        selectedId: {type: [Number, String], default: null},
        editable: {type: Boolean, default: true},
        disabled: Boolean
    },
    methods: {
        toggle(id, checked) {
            const next = this.value.filter(value => Number(value) !== Number(id));
            if (checked) next.push(Number(id));
            this.$emit('input', next);
        }
    }
};
</script>

<style scoped>
.employee-match-candidate { margin-top: .5rem; padding: .4rem .5rem; background: #f6f8fa; border-radius: .25rem; font-size: .78rem; }
.employee-match-candidate > a { font-weight: 600; overflow-wrap: anywhere; }
.employee-match-evidence { display: flex; flex-wrap: wrap; gap: .15rem .6rem; margin: .25rem 0; color: #667085; font-size: .72rem; }
.employee-match-evidence .text-warning { color: #946200 !important; }
</style>
